export { useUpstreamConditionalProperties } from './useUpstreamConditionalProperties'
